// Priority order for the Live Scores feed. Leagues listed here are forced to
// the top of the match list (lower index = higher priority), regardless of
// live state. IDs from API-Football: https://dashboard.api-football.com/soccer/ids/leagues
//
// SmartKick is a UK-focused app, so ALL British competitions (England,
// Scotland, Wales, Northern Ireland) sit at the very top, followed by the
// major European club competitions, then international / national-team games.
export const MAJOR_LEAGUE_IDS = [
  // ── British leagues — TOP priority (UK-focused audience) ──
  39,   // Premier League (England)
  40,   // EFL Championship
  41,   // EFL League One
  42,   // EFL League Two
  45,   // FA Cup
  48,   // EFL Cup (Carabao Cup)
  46,   // EFL Trophy
  179,  // Scottish Premiership
  180,  // Scottish Championship
  181,  // Scottish League One
  182,  // Scottish League Two / Challenge Cup
  183,  // Scottish FA Cup
  184,  // Scottish League Cup
  110,  // Cymru Premier (Wales)
  235,  // NIFL Premiership (Northern Ireland)
  408,  // NIFL Premiership (alt id)

  // ── Major European club competitions ──
  2,    // UEFA Champions League
  3,    // UEFA Europa League
  848,  // UEFA Europa Conference League
  140,  // La Liga (Spain)
  135,  // Serie A (Italy)
  78,   // Bundesliga (Germany)
  61,   // Ligue 1 (France)
  88,   // Eredivisie (Netherlands)
  94,   // Primeira Liga (Portugal)

  // ── International / national-team competitions ──
  1,    // FIFA World Cup
  15,   // FIFA Club World Cup
  4,    // UEFA Euro Championship
  9,    // Copa America
  5,    // UEFA Nations League
  10,   // International Friendlies
  32,   // WC Qualification — Europe
  34,   // WC Qualification — South America
  29,   // WC Qualification — Africa
  30,   // WC Qualification — Asia
  31,   // WC Qualification — CONCACAF
  37,   // WC Qualification — Intercontinental Play-offs

  // ── Other international club ──
  13,   // Copa Libertadores
];

// Quick lookup: leagueId -> priority index (lower = higher priority)
export const MAJOR_LEAGUE_PRIORITY = MAJOR_LEAGUE_IDS.reduce((acc, id, idx) => {
  acc[id] = idx;
  return acc;
}, {});

export const isMajorLeague = (id) => MAJOR_LEAGUE_PRIORITY[id] !== undefined;

// Competitions that are prioritised for ordering but have NO standings table
// (e.g. friendlies). They should not show the Table/Stats buttons.
const NO_TABLE_LEAGUES = new Set([
  10,   // International Friendlies
  666,  // Friendlies Women
]);

// True only for major competitions that actually have a league/group table,
// so we show the Table/Stats buttons and fetch standings for them.
export const hasLeagueTable = (id) => isMajorLeague(id) && !NO_TABLE_LEAGUES.has(id);
